import { BaseRoute } from 'src/routes/BaseRoute'
import { useSelector } from '.'

const useRoute = (): BaseRoute => {
  return useSelector(state => state.route)
}

export default useRoute
